import { combineReducers } from "redux";
import { printFeedsReducer } from "./printFeedsReducer";
import { onlineFeedsReducer } from "./onlineFeedsReducer";
import { entityAndKeyWordsReducer } from "./entity-and-keywords-reducer";
import { filterReducer } from "./filters-reducer";
import { clientReducer } from "./clients-reducer";
import { widgetReducer } from "./widget-reducer";
const reducers = {
  printFeedsReducer: printFeedsReducer,
  onlineFeedsReducer: onlineFeedsReducer,
  filterReducer: filterReducer,
  entityAndKeyWordsReducer: entityAndKeyWordsReducer,
  clientReducer: clientReducer,
  widgetReducer,
};

export const rootReducer = combineReducers(reducers);
